import client from "../client";

import { postFeedbackReviewConfig } from "./postFeedbackReviewConfig";
import { PostFeedbackReviewPayload } from "./types";

const postFeedbackReview = (data: PostFeedbackReviewPayload) => {
  return client({ ...postFeedbackReviewConfig(data.reference), data: { review: data.review } });
};

export default {
  postFeedbackReview,
};
